import ReactGA from "react-ga4";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useCurrentUser, useLogout, useFetchPractices } from "utils/hooks";
import { createPracticeAction } from "store/actions/practices";
import { formatInput } from "utils/helpers";

const useCreatePractice = () => {
  const dispatch = useDispatch();
  const { logOut } = useLogout();
  const { user } = useCurrentUser();
  const { fetchPractices } = useFetchPractices();

  const submitCreatePractice = async (args: any) => {
    if (!args) {
      return null;
    }

    const formatMultiSelectOptions = (selections: any) => {
      if (!selections) {
        return null;
      }
      return selections?.map((selection: any) => {
        return selection?.value;
      });
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
            mutation {
              createPractice(practice: {
                practiceName: "${formatInput(args.practiceName)}",
                treatmentType: "${formatMultiSelectOptions(
                  args.treatmentType
                )}",
                practiceSize: "${args.practiceSize?.value}",
                address1: "${formatInput(args.address1)}",
                address2: "${formatInput(args.address2)}",
                state: "${formatInput(args.state?.value)}",
                zipcode: "${formatInput(args.zipcode)}",
                phone: "${formatInput(args.phone)}",
                organizationId: "${user?.activeOrganizationId}",
              }) {
                uuid
                practiceName
                treatmentType
                practiceSize
                address1
                address2
                state
                zipcode
                phone
                slug
                organizationId
                status
                logoId
              }
            }
          `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "create_practices",
        },
      });

      const resData = await res.json();

      if (res.ok) {
        fetchPractices();
        toast("Your practice has been created");
        dispatch(createPracticeAction(resData.data.createPractice));
        ReactGA.event("practice_created_success", {
          user_id: user?.id,
          practice_id: resData.data.createPractice.uuid,
        });
      }

      if (!res.ok) {
        if (resData.errors[0].message.includes("BRKN_6001")) {
          toast.warn("For security purposes please log in again.");
          logOut();
        } else {
          toast.error(
            `Hmm, something went wrong. ${resData.errors[0].message}`
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  return {
    submitCreatePractice,
  };
};

export default useCreatePractice;
